//SECTION CHECKBOX

import { gql, useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import * as yup from 'yup';
import { addMessage, resetMessage } from "../../../../../stores/ReactiveVariables";
import { AccordionCheckbox } from "../AccordionCheckbox";

const GET_COVER_LETTER_PROJECT_ASSUMPTIONS_SECTION = gql`
    query GetCoverLetterProjectAssumptions($Id: uniqueidentifier = "") {
        BidQuotes_by_pk(Id: $Id) {
            CoverLetterProjectAssumptionsSection
        }
    }  
`;

const UPDATE_COVER_LETTER_PROJECT_ASSUMPTIONS_SECTION = gql`
    mutation UpdateCoverLetterProjectAssumption($Id: uniqueidentifier = "", $CoverLetterProjectAssumptionsSection: Boolean = false) {
        update_BidQuotes_by_pk(pk_columns: {Id: $Id}, _set: {CoverLetterProjectAssumptionsSection: $CoverLetterProjectAssumptionsSection}) {
            __typename
            Id
        }
    }
`;

interface ProjectAssumptionsCheckboxProps{
    id: string;
    getCoverLetter: () => void;
}

const validationSchema = yup.object().shape({
    CoverLetterProjectAssumptionsSection: yup.boolean(),
});

export const ProjectAssumptionsCheckbox: React.FC<ProjectAssumptionsCheckboxProps> = ({ id, getCoverLetter }: ProjectAssumptionsCheckboxProps) => {    
    const { data, loading, error } = useQuery(GET_COVER_LETTER_PROJECT_ASSUMPTIONS_SECTION, { variables: { Id: id } });
    const [updateCoverLetterProjectAssumptions] = useMutation(UPDATE_COVER_LETTER_PROJECT_ASSUMPTIONS_SECTION);

    const formData = data?.BidQuotes_by_pk;
    
    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: validationSchema,
        initialValues: {
            CoverLetterProjectAssumptionsSection: formData?.CoverLetterProjectAssumptionsSection ?? false,
        },
        onSubmit: (values: any) => {
            updateCoverLetterProjectAssumptions({
                variables: { Id: id, CoverLetterProjectAssumptionsSection: values.CoverLetterProjectAssumptionsSection },
                onCompleted: (data: any) => {
                    resetMessage();
                    const confirmMessage = values.CoverLetterProjectAssumptionsSection === true ? "Project Assumptions Added To Cover Letter" : "Project Assumptions Removed From Cover Letter";
                    addMessage(confirmMessage, { severity: 'success' });
                    getCoverLetter();
                },
                onError: () => {
                    addMessage('Error Saving/Removing Project Assumptions', { severity: 'error' });
                }
            });
        }
    });
    return (
        <AccordionCheckbox 
            getCoverLetter={getCoverLetter}
            name="CoverLetterProjectAssumptionsSection"
            checked={formik.values.CoverLetterProjectAssumptionsSection}
            onCheckboxClick={()=> formik.setFieldValue('CoverLetterProjectAssumptionsSection', !formik.values.CoverLetterProjectAssumptionsSection)}
            onSave={formik.submitForm}
            loading={loading}
        />
    )
}

